module.exports = __webpack_public_path__ + "static/media/ScreenShot_Footer_2020-06-27.baf2e405.png";